import PubSub from "underpub-js";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

var JumpNavigation = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-JumpNavigation',
  };

  $.extend(true, this.options, options);

};

JumpNavigation.prototype.init = function () {

  var self = this;

  self.$items = self.options.$el.find(`.${self.options.baseClass}__item`);

  self.$items.each((index, item) => {
    const $item = $(item);
    const target = $item.data("jump-navigation-target");
    const $section = $(`[data-jump-navigation-section="${target}"]`)[0];

    if (!target) return;

    $item.on("click", () => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: $section
        },
      });
    })
  })

};

export default JumpNavigation;